export default __webpack_public_path__ + "static/media/avatar_whitney7.6d18ee85.mp3";